import React from "react"
import CTA from "./CTA"
import {BsLinkedin, BsGithub,BsTwitter} from "react-icons/bs"
import {AiOutlineMail} from "react-icons/ai"
import "./header.css"

const Header = () => {
  return (
    <header>
      <div className="container header__container">
          <h5>Hello I'm</h5>
          <h1>Dev Goel</h1>
          <h5 className="text-light">Software Developer</h5>
          <CTA />
          <div className="header__socials">
            <a href="mailto:goeldev01@gmail.com" target="_blank" rel="noreferrer"><AiOutlineMail /> </a>
            <a href="https://twitter.com/goeldev01" target="_blank" rel="noreferrer"><BsTwitter /> </a>
            <a href="https://www.linkedin.com/in/dev-goel-833a25197/" target="_blank" rel="noreferrer"><BsLinkedin /> </a>
            <a href="https://github.com/devgoel186" target="_blank" rel="noreferrer"><BsGithub /> </a>
          </div>
          {/* <Me /> */}
      </div>
    </header>
  )
}

export default Header